<!-- Created by henian.xu on 2020/3/26. -->

<template>
    <Page>
        <Container >
            <div class="pa-a tc-g6 dp-fx fx-row fx-jc-sb fx-ai-c tc-danger">
                <XLabel>开票方式二选一</XLabel>
            </div>
            <CellGroup border>
                <Cell
                    direction="column"
                    label="1.线上开电子票"
                    extra="线上开票信息填报，直接获取电子发票"
                    @click.stop.prevent="()=>{
                        onAddOnlineInvoice()
                    }"
                    link
                />
                <Cell
                    direction="column"
                    label="2.线下开纸质票"
                    extra="需到校自取，现场签名《发票领取确认书》"
                    @click.stop.prevent="()=>{
                        onAddOfflineInvoice()
                    }"
                    link
                />
            </CellGroup>
            <div class="pa-a tc-g6 dp-fx fx-col fx-jc-fs fx-ai-sb">
                <div>客服电话：{{$globalVar.invoiceContactNumber}}</div>
                <div>学校地址：{{$globalVar.schoolAddress}}</div>
            </div>
        </Container>
    </Page>
</template>

<script>
import { invoiceAddMixin } from 'pages/Invoice/InvoiceStore';

export default {
    name: 'MethodPage',
    mixins: [invoiceAddMixin],
    data() {
        return {
            orderId: this.$route.query.orderId,
        };
    },
};
</script>

<style lang="scss">
</style>
